// authConfig.js — MSAL (Microsoft Authentication Library) setup for signing in to Outlook/Hotmail
// and calling Microsoft Graph to read mail. Client ID comes from an env var so it's never
// hardcoded into source — see .env.local.example for setup instructions.
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const GRAPH_SCOPES = ['Mail.Read', 'offline_access', 'User.Read'];

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    // "consumers" = personal Microsoft accounts only (outlook.com, hotmail.com, live.com).
    authority: 'https://login.microsoftonline.com/consumers',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage (not sessionStorage) so the signed-in session survives browser restarts —
    // MSAL will silently renew tokens from the cached refresh token without prompting again.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
